import { render, staticRenderFns } from "./GrupoAlerta.vue?vue&type=template&id=58dcaacf&scoped=true&lang=pug"
import script from "./GrupoAlerta.vue?vue&type=script&lang=js"
export * from "./GrupoAlerta.vue?vue&type=script&lang=js"
import style0 from "./GrupoAlerta.vue?vue&type=style&index=0&id=58dcaacf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dcaacf",
  null
  
)

export default component.exports